import React from 'react';
import { Search } from 'lucide-react';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  message: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-12 text-center"
    >
      <div className="bg-indigo-100 dark:bg-indigo-900 p-4 rounded-full mb-4">
        <Search className="text-indigo-600 dark:text-indigo-400" size={32} />
      </div>
      <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100 mb-2">No results found</h3>
      <p className="text-gray-600 dark:text-gray-400 max-w-md">{message}</p>
    </motion.div>
  );
};